import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs/Subject';
import { FormControl, FormGroup, Validators, FormBuilder } from '@angular/forms';

import { Compania } from '../shared/models/compania';
import { Ciudad } from '../shared/models/ciudad';
import { Sede } from '../shared/models/sede';
import { ListaItem } from '../shared/models/lista-item';
import { Vlan } from '../shared/models/vlan';
import { Asignacion } from '../shared/models/asignacion';
import { Solicitud } from '../shared/models/solicitud';
import { DireccionIp } from '../shared/models/direccion-ip';
import { TipoAsignacion } from '../shared/models/tipo-asignacion';
import { AsignacionManualDto } from '../shared/models/asignacion-manual-dto';
import { CompaniaService } from '../shared/services/compania.service';
import { CiudadService } from '../shared/services/ciudad.service';
import { SedeService } from '../shared/services/sede.service';
import { ListaItemService } from '../shared/services/lista-item.service';
import { VlanService } from '../shared/services/vlan.service';
import { TipoAsignacionService } from '../shared/services/tipo-asignacion.service';
import { AdministradorIpService } from '../shared/services/administrador-ip.service';
import { SesionService } from '../shared/services/sesion.service';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-asignacion-manual',
  templateUrl: './asignacion-manual.component.html',
  styleUrls: ['./asignacion-manual.component.css']
})
export class AsignacionManualComponent implements OnInit {
  modalAgregarFormGoup = this.formBuilder.group({
    urlControl: [''],
    servidorControl: ['', Validators.required],
    servicioControl: ['', Validators.required],
    plataformaControl: ['', Validators.required],
    rolControl: ['', Validators.required],
    controlObeservaciones: new FormControl(),
    controlDns: new FormControl(),
    checkDns: new FormControl()
  });

  private asignacionManual = environment.tipoAsignacionManual;
  private codigoListaAmbientes = environment.listaCodigoAmbientes;
  private codigoListaUrl = environment.listaCodigoUrl;
  private codigoListaServidor = environment.listaCodigoServidor;
  private codigoListaServicio = environment.listaCodigoServicio;
  private codigoListaPlataforma = environment.listaCodigoPlataforma;
  private codigoListaRol = environment.listaCodigoRol;
  private urlSubject = new Subject<string>();
  private servidorSubject = new Subject<string>();

  companias: Compania[];
  companiaSeleccionada: Compania = new Compania();
  ciudades: Ciudad[];
  sedes: Sede[];
  vlans: Vlan[];
  idCompaniaSeleccionada = -1;
  idCiudadSeleccionada = -1;
  idSedeSeleccionada = -1;
  idAmbienteSelecccionado = -1;
  idVlanSeleccionado = -1;
  ambientes: ListaItem[];
  tiposAsignacion: TipoAsignacion[];
  idTipoAsignacionSeleccionado: number;
  tipoasignacionSeleccionado: TipoAsignacion;
  ListaDirecciones: AsignacionManualDto[] = new Array<AsignacionManualDto>();
  direccionIp = '';
  modalRef: NgbModalRef;
  urls: ListaItem[];
  urlsFiltradas: ListaItem[];
  urlSeleccionado: ListaItem;
  servidores: ListaItem[];
  servidoresFiltrados: ListaItem[];
  servidorSeleccionado: ListaItem;
  servicios: ListaItem[];
  serviciosFiltrados: ListaItem[];
  servicioSeleccionado: ListaItem;
  plataformas: ListaItem[];
  plataformaFiltradas: ListaItem[];
  plataformaSeleccionado: ListaItem;
  roles: ListaItem[];
  rolesFiltrados: ListaItem[];
  rolSeleccionado: ListaItem;
  observaciones: string;
  dns = '';
  agregarActivo = false;
  agregarDns = false;
  solicitudSeleccionada: Solicitud = new Solicitud();
  indexSeleccionado: number;
  mensajeAlerta: string;
  permiso: boolean;
  error;
  @ViewChild('alertaModal') alertaModalRef: ElementRef;


  constructor(private companiaService: CompaniaService,
    private ciudadService: CiudadService, private sedeService: SedeService,
    private listaItemService: ListaItemService, private vlanService: VlanService,
    private tipoAsignacionService: TipoAsignacionService,
    private administradorIpService: AdministradorIpService,
    private modalService: NgbModal, private formBuilder: FormBuilder,
    private sesionService: SesionService) { }

  ngOnInit() {
    this.sesionService.permisoCrearVlan().subscribe(
      resultado => this.permiso = resultado
    );
    this.listarCompanias();
    this.listarTiposAsignacion();
    this.cargarListasDialogo();
    this.buscarTipoAsignacionManual();
  }

  public buscarTipoAsignacionManual(): void {
    this.tipoAsignacionService.tipoAsignacionPorNombre(this.asignacionManual).subscribe(
      resultado => { this.tipoasignacionSeleccionado = resultado;
        if (this.tipoasignacionSeleccionado == null) {
          this.mensajeAlerta = 'No se ha configurado el tipo de asignacion manual, contacte al administrador';
          this.modalRef = this.modalService.open(this.alertaModalRef, { size: 'lg' });
        } else {
            this.idTipoAsignacionSeleccionado = this.tipoasignacionSeleccionado.idTipoAsignacion;
        }

      }
    );
  }

  public listarCompanias(): void {
    this.companiaService.listarCompanias().subscribe(
      resultado => this.companias = resultado
    );
  }

  public listarCiudadaesPorCompania(): void {
    this.ListaDirecciones = new Array<AsignacionManualDto>();
    this.seleccionarCompania();
    this.idCiudadSeleccionada = -1;
    this.idSedeSeleccionada = -1;
    this.idAmbienteSelecccionado = -1;
    this.idVlanSeleccionado = -1;
    this.ciudades = null;
    this.sedes = null;
    this.ambientes = null;
    this.vlans = null;
    this.ciudadService.ciudadesPorIdCompania(this.idCompaniaSeleccionada).subscribe(
      resultado => this.ciudades = resultado
    );
  }

  public seleccionarCompania(): void {
    for (let i = 0; i < this.companias.length; i++) {
      if (this.companias[i].idCompania == this.idCompaniaSeleccionada) {
        this.companiaSeleccionada = this.companias[i];
      }
    }
  }

  public listarSedesPorCompaniaCiudad(): void {
    this.ListaDirecciones = new Array<AsignacionManualDto>();
    this.idSedeSeleccionada = -1;
    this.idAmbienteSelecccionado = -1;
    this.idVlanSeleccionado = -1;
    this.sedes = null;
    this.ambientes = null;
    this.vlans = null;
    this.sedeService.sedesPorCompaniaCiudad(this.idCompaniaSeleccionada, this.idCiudadSeleccionada).subscribe(
      resultado => this.sedes = resultado
    );
  }

  public listarAmbientes(): void {
    this.idAmbienteSelecccionado = -1;
    this.idVlanSeleccionado = -1;
    this.ambientes = null;
    this.vlans = null;
    this.listaItemService.ambientesPorCompaniaSedeValidaDMZ(this.idCompaniaSeleccionada,
      this.idSedeSeleccionada).subscribe(
      resultado => this.ambientes = resultado
    );
  }

  public listarVlanPorSedeAmbienteCompania(): void {
    this.ListaDirecciones = new Array<AsignacionManualDto>();
    this.idVlanSeleccionado = -1;
    this.vlans = null;
    this.vlanService.vlansPorSedeAmbienteCompania(this.idSedeSeleccionada,
      this.idAmbienteSelecccionado, this.idCompaniaSeleccionada, false).subscribe(
        resultado => this.vlans = resultado
      );
  }

  public listarTiposAsignacion(): void {
    this.tiposAsignacion = null;
    this.tipoAsignacionService.listarTiposAsignacion().subscribe(
      resultado => this.tiposAsignacion = resultado
    );
  }

  public buscarDirecciones(cargandoModal): void {
    if (this.idVlanSeleccionado != null) {
      this.modalRef = this.modalService.open(cargandoModal, { size: 'sm' });
      let direccion: string;
      if (this.direccionIp.length <= 0) {
        direccion = '-1';
      } else {
        direccion = this.direccionIp;
      }
      this.administradorIpService.consultarDireccionesIpAsignacionManual(this.idVlanSeleccionado, direccion).subscribe(
        resultado => { this.ListaDirecciones = resultado;
          this.modalRef.close();
        }
      );
    }
  }

  public abrirDialogoAgregarAsignacion(agregarModal, asignacionManual: AsignacionManualDto): void {
    this.indexSeleccionado = this.ListaDirecciones.indexOf(asignacionManual);
    this.limpiarDialogo();
    if (asignacionManual.asignacionActiva.idAsignacion != null) {
      if (asignacionManual.asignacionActiva.nombreURL != null) {
        this.urlSeleccionado = asignacionManual.asignacionActiva.nombreURL;
      }
      if (asignacionManual.asignacionActiva.nombreServidor != null) {
        this.servidorSeleccionado = asignacionManual.asignacionActiva.nombreServidor;
      }
      if (asignacionManual.asignacionActiva.servicioITNegocio != null) {
        this.servicioSeleccionado = asignacionManual.asignacionActiva.servicioITNegocio;
      }
      if (asignacionManual.asignacionActiva.plataforma != null) {
        this.plataformaSeleccionado = asignacionManual.asignacionActiva.plataforma;
      }
      if (asignacionManual.asignacionActiva.funcion != null) {
        this.rolSeleccionado = asignacionManual.asignacionActiva.funcion;
      }
      this.observaciones = asignacionManual.asignacionActiva.observaciones;
      this.agregarDns = asignacionManual.asignacionActiva.indicadorDns;
      this.dns = asignacionManual.asignacionActiva.configuracionDNS;
    }
    this.modalRef = this.modalService.open(agregarModal, { size: 'lg' });
  }

  cargarListasDialogo() {
    this.ListarUrl();
    this.ListarServidor();
    this.ListarServicio();
    this.ListarPlataformas();
    this.ListarRoles();
  }

  public limpiarDialogo(): void {
    this.urlSeleccionado = null;
    this.servidorSeleccionado = null;
    this.servicioSeleccionado = null;
    this.plataformaSeleccionado = null;
    this.rolSeleccionado = null;
    this.solicitudSeleccionada = new Solicitud();
    this.solicitudSeleccionada.tipoAsignacion = new TipoAsignacion();
    this.agregarDns = false;
    this.dns = '';
    this.observaciones = '';
    this.agregarDns = false;
  }

  public ListarUrl(): void {
    this.listaItemService.listaItemsPorCodigoListaHabilitado(this.codigoListaUrl).subscribe(
      resultado => this.urls = resultado
    );
  }

  public ListarServidor(): void {
    this.listaItemService.listaItemsPorCodigoListaHabilitado(this.codigoListaServidor).subscribe(
      resultado => this.servidores = resultado
    );
  }

  public ListarServicio(): void {
    this.listaItemService.listaItemsPorCodigoListaHabilitado(this.codigoListaServicio).subscribe(
      resultado => this.servicios = resultado
    );
  }

  public ListarPlataformas(): void {
    this.listaItemService.listaItemsPorCodigoListaHabilitado(this.codigoListaPlataforma).subscribe(
      resultado => this.plataformas = resultado
    );
  }

  public ListarRoles(): void {
    this.listaItemService.listaItemsPorCodigoListaHabilitado(this.codigoListaRol).subscribe(
      resultado => this.roles = resultado
    );
  }

  // Filtra los valores para el autocomplete
  filterRol(event) {
    this.rolesFiltrados = [];
    for (let i = 0; i < this.roles.length; i++) {
      const rol = this.roles[i];
      if (rol.valorItem.toUpperCase().indexOf(event.query.toUpperCase()) >= 0) {
        this.rolesFiltrados.push(rol);
      }
    }
      if (this.rolesFiltrados.length == 1 &&
      event.query.toUpperCase() == this.rolesFiltrados[0].valorItem) {
        this.rolSeleccionado = this.rolesFiltrados[0];
      } else {
        const rolNuevo: ListaItem = new ListaItem();
        rolNuevo.codigoItem = (this.roles.length + 1).toString();
        rolNuevo.indicadorHabilitado = true;
        rolNuevo.lista = this.roles[0].lista;
        rolNuevo.valorItem = event.query;
        rolNuevo.idListaItem = null;
        this.rolSeleccionado = rolNuevo;
      }
    }

    // Filtra los valores para el autocomplete
    filterPlataforma(event) {
      this.plataformaFiltradas = [];
      for (let i = 0; i < this.plataformas.length; i++) {
        const plataforma = this.plataformas[i];
        if (plataforma.valorItem.toUpperCase().indexOf(event.query.toUpperCase()) >= 0) {
          this.plataformaFiltradas.push(plataforma);
        }
      }
      if (this.plataformaFiltradas.length == 1  &&
      event.query.toUpperCase() == this.plataformaFiltradas[0].valorItem) {
        this.plataformaSeleccionado = this.plataformaFiltradas[0];
      } else {
        const itemNuevo: ListaItem = new ListaItem();
        itemNuevo.codigoItem = (this.plataformas.length + 1).toString();
        itemNuevo.indicadorHabilitado = true;
        itemNuevo.lista = this.plataformas[0].lista;
        itemNuevo.valorItem = event.query;
        itemNuevo.idListaItem = null;
        this.plataformaSeleccionado = itemNuevo;
      }
    }

    // Filtra los valores para el autocomplete
    filterServicio(event) {
      this.serviciosFiltrados = [];
      for (let i = 0; i < this.servicios.length; i++) {
        const servicio = this.servicios[i];
        if (servicio.valorItem.toUpperCase().indexOf(event.query.toUpperCase()) >= 0) {
          this.serviciosFiltrados.push(servicio);
        }
      }
      if (this.serviciosFiltrados.length == 1 &&
      event.query.toUpperCase() == this.serviciosFiltrados[0].valorItem) {
        this.servicioSeleccionado = this.serviciosFiltrados[0];
      } else {
        const itemNuevo: ListaItem = new ListaItem();
        itemNuevo.codigoItem = (this.servicios.length + 1).toString();
        itemNuevo.indicadorHabilitado = true;
        itemNuevo.lista = this.servicios[0].lista;
        itemNuevo.valorItem = event.query;
        itemNuevo.idListaItem = null;
        this.servicioSeleccionado = itemNuevo;
      }
    }

    // Filtra los valores para el autocomplete
    filterServidor(event) {
      this.servidoresFiltrados = [];
      for (let i = 0; i < this.servidores.length; i++) {
        const servidor = this.servidores[i];
        if (servidor.valorItem.toUpperCase().indexOf(event.query.toUpperCase()) >= 0) {
          this.servidoresFiltrados.push(servidor);
        }
      }
      if (this.servidoresFiltrados.length == 1  &&
      event.query.toUpperCase() == this.servidoresFiltrados[0].valorItem) {
        this.servidorSeleccionado = this.servidoresFiltrados[0];
      } else {
        const itemNuevo: ListaItem = new ListaItem();
        itemNuevo.codigoItem = (this.servidores.length + 1).toString();
        itemNuevo.indicadorHabilitado = true;
        itemNuevo.lista = this.servidores[0].lista;
        itemNuevo.valorItem = event.query;
        itemNuevo.valorItem = itemNuevo.valorItem.replace(new RegExp(' ', 'g'), '').trim();
        itemNuevo.idListaItem = null;
        this.servidorSeleccionado = itemNuevo;
      }
    }

    filterUrl(event) {
      this.urlsFiltradas = [];
      for (let i = 0; i < this.urls.length; i++) {
        const url = this.urls[i];
        if (url.valorItem.toUpperCase().indexOf(event.query.toUpperCase()) >= 0) {
          this.urlsFiltradas.push(url);
        }
      }
      if (this.urlsFiltradas.length == 1 &&
      event.query.toUpperCase() == this.urlsFiltradas[0].valorItem) {
        this.urlSeleccionado = this.urlsFiltradas[0];
      } else {
        const itemNuevo: ListaItem = new ListaItem();
        itemNuevo.codigoItem = (this.urls.length + 1).toString();
        itemNuevo.indicadorHabilitado = true;
        itemNuevo.lista = this.urls[0].lista;
        itemNuevo.valorItem = event.query;
        itemNuevo.valorItem = itemNuevo.valorItem.replace(new RegExp(' ', 'g'), '').trim();
        itemNuevo.idListaItem = null;
        this.urlSeleccionado = itemNuevo;
      }
    }

    // Sttea la nueva asignacion y la envia a guardar
    guardarAsignacionManual(cargandoModal): void {
      this.ListaDirecciones[this.indexSeleccionado].asignacionNueva = this.settearAsignacion();
      this.modalRef.close();
      this.modalRef = this.modalService.open(cargandoModal);
      this.administradorIpService.guardarAsignacionManual(this.ListaDirecciones[this.indexSeleccionado]).subscribe(
        resultado => { this.ListaDirecciones[this.indexSeleccionado] = resultado;
          this.cargarListasDialogo();
          this.modalRef.close();
        }, error => {
          this.error = error;
          this.modalRef.close();
        }
      );
    }

    // Settea la asignacion nueva con los valores seleccionados en el dialogo
    settearAsignacion(): Asignacion {
      const asignacion: Asignacion = new Asignacion();
      asignacion.compania = this.companiaSeleccionada;
      if (this.dns != null) {
        asignacion.configuracionDNS = this.dns.toUpperCase();
      }
      asignacion.direccionIp = new DireccionIp();
      asignacion.direccionIp.idDireccionIp = this.ListaDirecciones[this.indexSeleccionado].idDireccionIp;
      this.rolSeleccionado.valorItem = this.rolSeleccionado.valorItem.toUpperCase();
      asignacion.funcion = this.rolSeleccionado;
      asignacion.indicadorDns = this.agregarDns;
      this.servidorSeleccionado.valorItem = this.servidorSeleccionado.valorItem.toUpperCase();
      asignacion.nombreServidor = this.servidorSeleccionado;
      if (this.observaciones != null) {
        asignacion.observaciones = this.observaciones.toUpperCase();
      }
      this.plataformaSeleccionado.valorItem = this.plataformaSeleccionado.valorItem.toUpperCase();
      asignacion.plataforma = this.plataformaSeleccionado;
      this.servicioSeleccionado.valorItem = this.servicioSeleccionado.valorItem.toUpperCase();
      asignacion.servicioITNegocio = this.servicioSeleccionado;
      asignacion.tipoAsignacion = this.tipoasignacionSeleccionado;
      if (this.urlSeleccionado != null && this.modalAgregarFormGoup.controls['urlControl'].value.length != '' ) {
        this.urlSeleccionado.valorItem = this.urlSeleccionado.valorItem.toUpperCase();
        asignacion.nombreURL = this.urlSeleccionado;
      }
      return asignacion;
    }

    // Metodo que limpia la lista de ip's al cambiar de vlan seleccionada
    onChangeVlan(): void {
      this.ListaDirecciones = new Array<AsignacionManualDto>();
    }

    // Valida y guarda aquellas listaItem que crea nuevas el usuario
    public validarListas(listaItem: ListaItem): ListaItem {
      if (listaItem.idListaItem == null && listaItem.valorItem.length > 0) {
        this.guardarListaItem(listaItem).then(resultado => {
          resultado = listaItem;
        });
      }
      return listaItem;
    }

    // Guarda ListaItem
    public async guardarListaItem(listaItem: ListaItem): Promise<ListaItem> {
      let listaItemGuardado: ListaItem = new ListaItem();
      if (listaItem != null && listaItem.codigoItem != null && listaItem.valorItem != null) {
        listaItemGuardado = await this.listaItemService.guardarListaAsync(listaItem);
      }
      return listaItemGuardado;
    }
}



// WEBPACK FOOTER //
// ./src/app/asignacion-manual/asignacion-manual.component.ts